var module = angular.module('octopusApp.library');

module.controller('PackageDetailsController', function($scope, $location, $stateParams, busy, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();

  var packageId = $stateParams["packageId"];

  isLoading.promise(octopusRepository.Packages.get(packageId, {includeNotes: true}).then(function(pkg){
    $scope.package = pkg;
  }));
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/library/packages/controllers/package_details_controller.js
// module id = 7043389113953917
// module chunks = 1